var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPoundCrossedOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-139 -170)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(139 170)",
    fill: "#3a4557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pound-sign-solid_1_",
    "data-name": "pound-sign-solid(1)",
    d: "M9.625,42H8.2a.375.375,0,0,0-.375.375v1.589H4V40H6.625A.375.375,0,0,0,7,39.625v-1.25A.375.375,0,0,0,6.625,38H4V36.014A1.79,1.79,0,0,1,5.931,34.23a3.61,3.61,0,0,1,1.8.589.375.375,0,0,0,.49-.084l.89-1.11a.375.375,0,0,0-.066-.534A5.37,5.37,0,0,0,5.873,32C3.313,32,1.5,33.648,1.5,35.936V38H.625a.375.375,0,0,0-.375.375v1.25A.375.375,0,0,0,.625,40H1.5v4H.375A.375.375,0,0,0,0,44.375v1.25A.375.375,0,0,0,.375,46h9.25A.375.375,0,0,0,10,45.625v-3.25A.375.375,0,0,0,9.625,42Z",
    transform: "translate(146 142.667)",
    fill: "#fc1",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 14,
    y2: 18,
    transform: "translate(144.5 172.5)",
    fill: "none",
    stroke: "#fc1",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoundCrossedOut);
export default __webpack_public_path__ + "static/media/icon_pound-crossed-out.10519240fc7eb770d410e05d24acf303.svg";
export { ForwardRef as ReactComponent };